import { useState, useEffect } from 'react';
import { getContentByLanguage, languages } from '../data/staticData';

// Dil yönetimi hook'u
export const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('tr');
  const [content, setContent] = useState(getContentByLanguage('tr'));

  useEffect(() => {
    // Sayfa yüklendiğinde kayıtlı dili al, yoksa Türkçe varsayılan
    const savedLanguage = localStorage.getItem('selectedCountry');
    if (savedLanguage) {
      const languageData = languages.find(lang => lang.ID === savedLanguage);
      if (languageData) {
        setCurrentLanguage(languageData.code);
        setContent(getContentByLanguage(languageData.code));
      } else {
        // Kayıtlı dil bulunamazsa Türkçe'ye dön
        setCurrentLanguage('tr');
        setContent(getContentByLanguage('tr'));
        localStorage.setItem('selectedCountry', '0'); // Türkçe ID'si
      }
    } else {
      // Hiç kayıtlı dil yoksa Türkçe'yi varsayılan yap
      setCurrentLanguage('tr');
      setContent(getContentByLanguage('tr'));
      localStorage.setItem('selectedCountry', '0'); // Türkçe ID'si
    }
  }, []);

  const changeLanguage = (languageCode) => {
    const languageData = languages.find(lang => lang.code === languageCode);
    if (languageData) {
      setCurrentLanguage(languageCode);
      setContent(getContentByLanguage(languageCode));
      localStorage.setItem('selectedCountry', languageData.ID);
      // Sayfa yenileme yerine state güncellemesi
      window.location.reload();
    }
  };

  return {
    currentLanguage,
    content,
    changeLanguage,
    languages
  };
};
